// src/state/authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const savedToken = localStorage.getItem("token");
const savedUser = null; // If you later store user JSON: JSON.parse(localStorage.getItem("user") || "null");

const initialState = {
  isAuthenticated: !!savedToken,
  token: savedToken || null,
  user: savedUser,
  requiresPasswordChange: localStorage.getItem("requiresPasswordChange") === "true",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.token = action.payload.token ?? null;
      state.user = action.payload.user ?? null;
      state.requiresPasswordChange = !!action.payload.requiresPasswordChange;
    },
    clearPasswordChangeRequirement(state) {
      state.requiresPasswordChange = false;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.requiresPasswordChange = false;
      // Note: localStorage clearing is handled in the Navbar logout handler.
      // If you prefer, you can also clear here—but reducers should be pure.
    },
  },
});

export const { login, logout, clearPasswordChangeRequirement } = authSlice.actions;
export default authSlice.reducer;
